<template>
  <div class="inquiry-quotation">
    <ContentBlock style="padding: 0 10px 20px 10px;">
      <div class="topTitleContainer">
        <div class="topTitleContainer-left">
          询价单状态
          <el-tooltip
            effect="dark"
            placement="top-start">
            <div slot="content">供应商待接单：没有供应商接单；<br/>供应商待报价：没有供应商报价；<br/>待关单：已处理完报价需要关单；</div>
            <i class="el-icon-question" style="color:#a9a9a9; margin-left:5px;font-size: 14px;"></i>
          </el-tooltip>
          <el-checkbox-group v-model="outform.statuses" @change="handleSearch" style="margin-left: 14px;">
            <el-checkbox-button @change="((val) => itemChange(val, item))" v-for="item in statusList" :key="item.value" :label="item.value">{{ `${item.label}${item.count ? `(${item.count})` : ''}` }}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <el-tooltip
          effect="dark"
          placement="bottom-end"
          content="仅体现双方基于小紫【供需通】的线上报价，最终确认价格以双方签订的合同或订单为依据。"
          >
          <span class="help">
            帮助
            <i class="el-icon-question" style="color:#a9a9a9; margin-left:5px;font-size: 14px;"></i>
          </span>
        </el-tooltip>
      </div>
      <expand-table
        class="content_block"
        ref="expandTable"
        :toolBar="toolBar"
        :showRightToolbar="true"
        :columnList="orderTableColumns"
        :tableData="targetLists"
        :expandConfig="expandConfig"
        :pagination.sync="pagination"
        :sortInfo.sync="updateSortInfo"
        :tooltipConfig="tooltipConfig"
        @size-change="getTargetLists"
        @current-change="getTargetLists"
        @sort-change="getTargetLists"
        @handleToggleRowExpand="handleToggleRowExpand"
      />
    </ContentBlock>
      <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShowAdvanced" :wrapperClosable="false" :close-on-click-modal="false" @closed="isShowAdvanced = false"
        :append-to-body="true"
        :z-index="9001"
        :close-on-press-escape="false"
      >
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="业务类型">
              <el-select v-model.trim="form.businessType" placeholder="请选择" clearable :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="维修" value="MAINTAIN"></el-option>
                <el-option label="备件" value="SPARE_PART"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="询单来源">
              <el-select v-model.trim="form.inquireSource" placeholder="请选择" clearable :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="平台询单" :value="1"></el-option>
                <el-option label="资管易询单" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="终端用户">
              <el-input placeholder="请输入" v-model.trim="form.terminalCustomer" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="询价单位">
              <el-input placeholder="请输入" v-model.trim="form.inquirePriceParty" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="创建人">
              <el-input placeholder="请输入" v-model.trim="form.createUserName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="创建日期">
              <el-row>
                <el-col :span='11'>
                  <el-date-picker v-model="form.createTimeStart" type="date" value-format="yyyy-MM-dd" :append-to-body="false"
                    placeholder="选择创建开始日期">
                  </el-date-picker>
                </el-col>
                <el-col :span='2' style="text-align: center; color: rgb(220, 223, 230);">—</el-col>
                <el-col :span='11'>
                  <el-date-picker v-model="form.createTimeEnd" type="date" value-format="yyyy-MM-dd" :append-to-body="false"
                    placeholder="选择创建结束日期">
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="紧急程度">
              <el-select v-model.trim="form.emergencyLevel" placeholder="请选择" clearable :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="高" value="HIGH"></el-option>
                <el-option label="中" value="MEDIUM"></el-option>
                <el-option label="低" value="LOW"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>
    <el-dialog
      top="5vh"
      width="1350px"
      v-if="isShow"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      @closed="isShow = false"
      :append-to-body='true'
      :key="timer"
      :fullscreen="isFullscreen"
      :show-close="false"
      class="RFQ-detail-dialog"
    >
      <div slot="title" class="dialog-title">
        <span>询价单详情</span>
        <div class="titleButtonContainer">
          <vxe-button type="text" @click="isFullscreen = !isFullscreen">
            <img :src="require('@/assets/table/ic_zhankai.svg')" v-if="isFullscreen">
            <img :src="require('@/assets/table/ic_shouqi.svg')" v-else>
          </vxe-button>
          <vxe-button type="text" icon="vxe-icon-close" @click="isShow = false"></vxe-button>
        </div>
      </div>
      <div class="RFQ-detail-dialog-content">
        <Detail :params="detailParams" />
      </div>
    </el-dialog>
    <closeInquiry ref="closeInquiry" @refresh="getTargetLists" />
  </div>
</template>
<script>
import { TablePaginationMixin } from '@/components/common/TableWithPagination';
import ExpandTable from '@/components/common/ExpandTable';
import { setOrderTableColumns } from './config/index';
import closeInquiry from './component/closeInquiry.vue';
import { getCountInquiry, pageListByInquiry } from '@/api/RFQ';
import Detail from './detail';
export default {
  mixins: [TablePaginationMixin],
  components: {
    ExpandTable,
    closeInquiry,
    Detail,
  },
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入需求单号/询单号' style='width:250px;' v-model={this.outform.codeOrRequirementCode}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icAdvanceSearch = require('@/assets/table/ic_advanceSearch.svg'); // eslint-disable-line no-undef
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            const icRefresh = require('@/assets/table/ic_refresh.svg'); // eslint-disable-line no-undef
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    orderTableColumns () {
      return setOrderTableColumns.call(this, this.type);
    },
  },
  data () {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      statusList: [
        { label: '全部', value: 'All' },
        { label: '供应商待接单', value: 'NOT_TASK_ORDER', count: 0 },
        { label: '供应商部分接单', value: 'PART_TASK_ORDER', count: 0 },
        { label: '供应商已接单', value: 'ALL_TASK_ORDER', count: 0 },
        { label: '供应商待报价', value: 'NOT_QUOTE_PRICE', count: 0 },
        { label: '供应商部分报价', value: 'PART_QUOTE_PRICE', count: 0 },
        { label: '供应商已报价', value: 'ALL_QUOTE_PRICE', count: 0 },
        { label: '询价中', value: 'BE_BEING' },
        { label: '待关单', value: 'NOT' },
        { label: '已关单', value: 'FINISHED' },
      ],
      isExpand: 1,
      expandConfig: {
        accordion: false,
        lazy: false,
        expandAll: true,
        reserve: true,
      },
      tooltipConfig: {
        contentMethod: ({ row, column }) => {
          if (column.property === 'receiverName') {
            const keys = ['name', 'phone', 'provinceName', 'cityName', 'areaName', 'address'];
            let info = '';
            for (let k of keys) {
              if (row.receiver && row.receiver[k]) {
                info += `${row.receiver[k]}\n`;
              }
            }
            info = info.replace(/\n$/, '');
            return info;
          }
        },
      },
      outform: {
        codeOrRequirementCode: '',
        statuses: ['All'],
        taskOrderStatuses: [],
        quotePriceStatuses: [],
      },
      form: {
        businessType: '',
        inquireSource: '',
        terminalCustomer: '',
        inquirePriceParty: '',
        createUserName: '',
        createTimeStart: '',
        createTimeEnd: '',
        emergencyLevel: '',
      },
      columnList: [
        {
          tooltip: true,
          label: '备件码',
          prop: 'originalCode',
          minWidth: '140px',
        },
      ],
      targetLists: [],
      isFullscreen: false,
      isShow: false,
      timer: new Date().getTime(),
      detailParams: {},
      isShowAdvanced: false,
    };
  },
  methods: {
    handleAdvancedSearch () {
      this.isShowAdvanced = true;
    },
    handleQuery () {
      this.pagination.currentPage = 1;
      this.getTargetLists();

      this.isShowAdvanced = false;
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.pagination.currentPage = 1;
    },
    handleToggleExpand () {
      this.isExpand = this.isExpand === 3 ? 1 : 3;
      this.$nextTick(() => {
        this.$refs.expandTable.$refs.vxeTable.setAllRowExpand(this.isExpand === 1);
      });
    },
    handleToggleRowExpand () {
      let records = this.$refs.expandTable.$refs.vxeTable.getRowExpandRecords();
      if (records && records.length) {
        this.isExpand = records.length === this.targetLists.length ? 1 : 2;
      } else {
        this.isExpand = 3;
      }
    },
    handleShowDetail (row) {
      this.detailParams = {
        id: row.id,
        deal: 'no',
      };
      this.isShow = true;
    },
    handleClose (row) {
      this.$refs.closeInquiry.form.id = row.id;
      this.$refs.closeInquiry.inquireSource = row.inquireSource;
      this.$refs.closeInquiry.visible = true;
    },
    itemChange (check, item) {
      // 如果当前选中全部，将其他选项置空
      if (check && item.value === 'All') {
        this.outform.statuses = ['All'];
      } else
      // 如果当前选中其他，把全选删除
      if (check && item.value !== 'All') {
        this.outform.statuses = this.outform.statuses.filter(status => status !== 'All');
      } else
      // 如果当前取消选中，看是否还有选中状态，有：不处理，无：默认成全部
      if (!check && !this.outform.statuses.length) {
        this.outform.statuses = ['All'];
      }
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    handleReset () {
      this.outform = this.$options.data().outform;
      this.form = this.$options.data().form;
      this.pagination.currentPage = 1;
      this.getInquiryCount();
      this.getTargetLists();
    },
    async getInquiryCount () {
      const { body } = await getCountInquiry({});
      this.statusList.map(item => {
        if (item.value === 'NOT_TASK_ORDER') item.count = body.notTaskOrderCount || 0;
        if (item.value === 'PART_TASK_ORDER') item.count = body.partTaskOrderCount || 0;
        if (item.value === 'ALL_TASK_ORDER') item.count = body.allTaskOrderCount || 0;
        if (item.value === 'NOT_QUOTE_PRICE') item.count = body.notQuotePriceCount || 0;
        if (item.value === 'PART_QUOTE_PRICE') item.count = body.partQuotePriceCount || 0;
        if (item.value === 'ALL_QUOTE_PRICE') item.count = body.allQuotePriceCount || 0;
        return item;
      });
    },
    async getTargetLists () {
      let params = {
        ...this.form,
        ...this.outform,
        createTimeStart: this.form.createTimeStart ? (new Date(`${this.form.createTimeStart} 00:00:00`)).getTime() : undefined,
        createTimeEnd: this.form.createTimeEnd ? (new Date(`${this.form.createTimeEnd} 23:59:59`)).getTime() : undefined,
        codeOrRequirementCode: this.outform.codeOrRequirementCode,
        taskOrderStatuses: [],
        quotePriceStatuses: [],
        statuses: [],
        pageFlag: true,
        findNotQuoteSupplierFlag: true,
        findSupplierQuotePriceFlag: true,
        onlyCountTotal: true,
        unionFlag: true,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (!this.outform.statuses.includes('All')) {
        this.outform.statuses.map(status => {
          if (['NOT_TASK_ORDER', 'PART_TASK_ORDER', 'ALL_TASK_ORDER'].includes(status)) {
            params.taskOrderStatuses.push(status);
          }
          if (['NOT_QUOTE_PRICE', 'PART_QUOTE_PRICE', 'ALL_QUOTE_PRICE'].includes(status)) {
            params.quotePriceStatuses.push(status);
          }
          if (['NOT', 'FINISHED', 'BE_BEING'].includes(status)) {
            params.statuses.push(status);
          }
        });
      }

      const { body } = await pageListByInquiry(params);
      this.pagination.total = body.total * 1 || 0;
      this.targetLists = (body.list || []);
    },
  },
  mounted () {
    this.getInquiryCount();
    this.getTargetLists();
  },
};
</script>
<style lang="scss" scoped>
.inquiry-quotation {
  /deep/ .el-checkbox-button--small .el-checkbox-button__inner {
    padding: 8px;
  }
  /deep/ .topTitleContainer{
    height: 60px;
    background: #FFFFFF;
    box-shadow: inset 0px -1px 0px 0px #DFE2E8;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    .topTitleContainer-left {
      display: inline-flex;
      align-items: center;
    }
    .help {
      font-weight: 400;
      font-size: 14px;
      color: #0091FF;
    }
  }
  /deep/.vxe-tools--wrapper {
    display: flex;
    justify-content: space-between;

    &>.el-button {
      margin-left: 0.5em;
    }

    &>div.el-input {
      margin-left: 0.5em;
    }

    &>.vxe-button {
      margin-left: 0.5em;
    }
  }
  /deep/ .vxe-tools--operate {
    &>.vxe-button {
      margin-left: 0.5em;
    }
  }
}
.RFQ-detail-dialog {
  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 0 10px;
  }
  .RFQ-detail-dialog-content {
    max-height: calc(100vh - 5vh - 200px);
    overflow: auto;
    margin-bottom: 30px;
  }
}
</style>
